import { Component, OnDestroy, AfterViewInit, Input, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { forwardRef } from "@angular/core";


export const CONTENTEDITABLE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ContentEditable),
  multi: true
};
@Component({
  selector: 'content-editable',
  template: `<div #contentDiv contenteditable="true" [ngStyle]="{'height.px': height }"></div>`,
  providers: [CONTENTEDITABLE_VALUE_ACCESSOR]
})
export class ContentEditable implements AfterViewInit, OnDestroy, ControlValueAccessor {

  // private content: string = '';

  //Placeholders for the callbacks which are later providesd
  //by the Control Value Accessor
  private onTouchedCallback: () => void;
  private onChangeCallback: (_: any) => void;

  @Input() height: number = 200;
  @Output() initialized: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('contentDiv') contentDiv: ElementRef;
    
  ngAfterViewInit() {
    
    document.execCommand("defaultParagraphSeparator", false, "p");
    
    this.contentDiv.nativeElement.addEventListener('blur', (ev)=>{
      this.onTouchedCallback();
    });
    
    this.contentDiv.nativeElement.addEventListener('input', (ev)=>{
      this.onChangeCallback(ev.target.innerHTML);
    });
    
  }
  
  set value(value: string){
    this.contentDiv.nativeElement.innerHTML = value;
  }

  //From ControlValueAccessor interface
  writeValue(value: string) { 
    if(typeof value !== 'string') value = '';
        
    this.value = value;
  }
  
  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  ngOnDestroy() {
    //tinymce.remove(this.editor);
  }
  
}



// WEBPACK FOOTER //
// ./src/partials/contenteditable/contenteditable.ts